type TrialDates = {
  start_at?: string | null;
  end_at?: string | null;
};

export const contractRangeFromTrials = (trials: TrialDates[]): { start: string; end: string } => {
  const starts = trials.map((trial) => trial.start_at).filter(Boolean) as string[];
  const ends = trials.map((trial) => trial.end_at).filter(Boolean) as string[];

  starts.sort();
  ends.sort();

  return {
    start: starts[0] ?? '',
    end: ends[ends.length - 1] ?? '',
  };
};
